module.exports = __webpack_public_path__ + "img/3.2.3c7a1cb5.png";